"use client";
import Script from "./template/Script";
import Modals from "./template/Modals";
export { Script, Modals };
